// src/utils/compact.ts
var compact = (object) => {
  const clone = { ...object };
  for (const key in clone) {
    if (clone[key] === void 0) {
      delete clone[key];
    }
  }
  return clone;
};

export {
  compact
};
